import { format } from 'date-fns';

import { DonorSchedule } from '@/rtk-query.gql';

export enum DonorSchedulingActions {
  INCREMENT_REFETCH_TRIGGER = 'donorScheduling/INCREMENT_REFETCH_TRIGGER',
  RESET_SELECTED_DONOR_SCHEDULING = 'donorScheduling/RESET_SELECTED_DONOR_SCHEDULING',
  RESET_WORKING_DONOR_SCHEDULE = 'donorScheduling/RESET_WORKING_DONOR_SCHEDULE',
  UPDATE_ASPIRATION_SITE = 'donorScheduling/UPDATE_ASPIRATION_SITE',
  UPDATE_BACKUP_SEMEN = 'donorScheduling/UPDATE_BACKUP_SEMEN',
  UPDATE_BACKUP_SEMEN_TYPE = 'donorScheduling/UPDATE_BACKUP_SEMEN_TYPE',
  UPDATE_BACKUP_SIRE = 'donorScheduling/UPDATE_BACKUP_SIRE',
  UPDATE_BILL_DONOR_PARTNERSHIP_STATUS = 'donorScheduling/UPDATE_BILL_DONOR_PARTNERSHIP_STATUS',
  UPDATE_BILL_DRUGS = 'donorScheduling/UPDATE_BILL_DRUGS',
  UPDATE_BILLING_ACCOUNT = 'donorScheduling/UPDATE_BILLING_ACCOUNT',
  UPDATE_CANE = 'donorScheduling/UPDATE_CANE',
  UPDATE_CLINIC_RANCH_HAUL_IN = 'donorScheduling/UPDATE_CLINIC_RANCH_HAUL_IN',
  UPDATE_COLLECTION_CODE = 'donorScheduling/UPDATE_COLLECTION_CODE',
  UPDATE_CONTRACT_SEMEN = 'donorScheduling/UPDATE_CONTRACT_SEMEN',
  UPDATE_CREDIT_REBILL = 'donorScheduling/UPDATE_CREDIT_REBILL',
  UPDATE_CRITICAL = 'donorScheduling/UPDATE_CRITICAL',
  UPDATE_CSR = 'donorScheduling/UPDATE_CSR',
  UPDATE_CSR_FRZ_TRF = 'donorScheduling/UPDATE_CSR_FRZ_TRF',
  UPDATE_DATE = 'donorScheduling/UPDATE_DATE',
  UPDATE_DONOR = 'donorScheduling/UPDATE_DONOR',
  UPDATE_DONOR_COMMENT = 'donorScheduling/UPDATE_DONOR_COMMENT',
  UPDATE_DONOR_LOCATION = 'donorScheduling/UPDATE_DONOR_LOCATION',
  UPDATE_DOW = 'donorScheduling/UPDATE_DOW',
  UPDATE_DRUG_SHIPPING_FEE = 'donorScheduling/UPDATE_DRUG_SHIPPING_FEE',
  UPDATE_EMBRYO_COMMENT = 'donorScheduling/UPDATE_EMBRYO_COMMENT',
  UPDATE_EXPECTED_SEMEN_QTY = 'donorScheduling/UPDATE_EXPECTED_SEMEN_QTY',
  UPDATE_EXPORT = 'donorScheduling/UPDATE_EXPORT',
  UPDATE_NON_EU_COUNTRY = 'donorScheduling/UPDATE_NON_EU_COUNTRY',
  UPDATE_FERTILIZATION_SITE = 'donorScheduling/UPDATE_FERTILIZATION_SITE',
  UPDATE_FREEZE = 'donorScheduling/UPDATE_FREEZE',
  UPDATE_FREEZE_INSTRUCTIONS = 'donorScheduling/UPDATE_FREEZE_INSTRUCTIONS',
  UPDATE_FREEZE_METHOD = 'donorScheduling/UPDATE_FREEZE_METHOD',
  UPDATE_FSH_DRUG_1 = 'donorScheduling/UPDATE_FSH_DRUG_1',
  UPDATE_FSH_DRUG_2 = 'donorScheduling/UPDATE_FSH_DRUG_2',
  UPDATE_IMPLANT_TYPE = 'donorScheduling/UPDATE_IMPLANT_TYPE',
  UPDATE_ID = 'donorScheduling/UPDATE_ID',
  UPDATE_NAME = 'donorScheduling/UPDATE_NAME',
  UPDATE_OWNER = 'donorScheduling/UPDATE_OWNER',
  UPDATE_OWNER_ID = 'donorScheduling/UPDATE_OWNER_ID',
  UPDATE_POOL = 'donorScheduling/UPDATE_POOL',
  UPDATE_PREGNANT = 'donorScheduling/UPDATE_PREGNANT',
  UPDATE_PRIORITY = 'donorScheduling/UPDATE_PRIORITY',
  UPDATE_PROCEDURE_TIME = 'donorScheduling/UPDATE_PROCEDURE_TIME',
  UPDATE_PROGRAM_NAME = 'donorScheduling/UPDATE_PROGRAM_NAME',
  UPDATE_QUICK_FILTER_TEXT = 'donorScheduling/UPDATE_QUICK_FILTER_TEXT',
  UPDATE_SCHEDULE_MASTER = 'donorScheduling/UPDATE_SCHEDULE_MASTER',
  UPDATE_SEMEN = 'donorScheduling/UPDATE_SEMEN',
  UPDATE_SEMEN_COMMENT = 'donorScheduling/UPDATE_SEMEN_COMMENT',
  UPDATE_SEMEN_LOCATION = 'donorScheduling/UPDATE_SEMEN_LOCATION',
  UPDATE_SEMEN_OWNER = 'donorScheduling/UPDATE_SEMEN_OWNER',
  UPDATE_SEMEN_PRICE = 'donorScheduling/UPDATE_SEMEN_PRICE',
  UPDATE_SEMEN_RELEASED = 'donorScheduling/UPDATE_SEMEN_RELEASED',
  UPDATE_SEMEN_TYPE = 'donorScheduling/UPDATE_SEMEN_TYPE',
  UPDATE_SEPARATE_FERT = 'donorScheduling/UPDATE_SEPARATE_FERT',
  UPDATE_SHIP = 'donorScheduling/UPDATE_SHIP',
  UPDATE_SHIPMENT_GROUP = 'donorScheduling/UPDATE_SHIPMENT_GROUP',
  UPDATE_SIRE = 'donorScheduling/UPDATE_SIRE',
  UPDATE_SPECIAL_INSTRUCTIONS = 'donorScheduling/UPDATE_SPECIAL_INSTRUCTIONS',
  UPDATE_TARGET_TIME = 'donorScheduling/UPDATE_TARGET_TIME',
  UPDATE_TEXTING_ACCOUNT = 'donorScheduling/UPDATE_TEXTING_ACCOUNT',
  UPDATE_TEXTING_NUMBER = 'donorScheduling/UPDATE_TEXTING_NUMBER',
  UPDATE_TT = 'donorScheduling/UPDATE_TT',
  UPDATE_TRANSFER = 'donorScheduling/UPDATE_TRANSFER',
  UPDATE_MERGED_DONOR_SCHEDULE = 'donorScheduling/UPDATE_MERGED_DONOR_SCHEDULE',
  UPDATE_WORKING_DONOR_SCHEDULE = 'donorScheduling/UPDATE_WORKING_DONOR_SCHEDULE',
  UPDATE_SELECTED_DONOR_SCHEDULES = 'donorScheduling/UPDATE_SELECTED_DONOR_SCHEDULES',
  UPDATE_BILL_ACCOUNT_CANING_OPTIONS = 'donorScheduling/UPDATE_BILL_ACCOUNT_CANING_OPTIONS',
  UPDATE_SO_SCHEDULE = 'donorScheduling/UPDATE_SO_SCHEDULE',
  UPDATE_ESTIMATIONS = 'donorScheduling/UPDATE_ESTIMATIONS',
  UPDATE_REVISION_COMMENT = 'donorScheduling/UPDATE_REVISION_COMMENT',
}

export type DonorSchedulingType = {
  quickFilterText: string;
  selectedDonorSchedules: DonorSchedule[];
  workingDonorSchedule: DonorSchedule | null;
  mergedDonorSchedules?: DonorSchedule | null;
  refetchTrigger: number;
};

export const initialWorkingDonorSchedule = {
  pool: false,
  targetTime: true,
  billDrugs: false,
  drugShippingFee: 100000000,
  tt: false,
  separateFert: false,
  creditRebill: false,
  contractSemen: false,
  semenReleased: false,
};

export const initialState: DonorSchedulingType = {
  quickFilterText: '',
  selectedDonorSchedules: [],
  workingDonorSchedule: initialWorkingDonorSchedule as DonorSchedule,
  mergedDonorSchedules: null,
  refetchTrigger: 0,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case DonorSchedulingActions.UPDATE_QUICK_FILTER_TEXT: {
      return {
        ...state,
        quickFilterText: action.payload,
      };
    }
    case DonorSchedulingActions.UPDATE_SELECTED_DONOR_SCHEDULES: {
      return {
        ...state,
        selectedDonorSchedules: action.payload,
      };
    }
    case DonorSchedulingActions.UPDATE_MERGED_DONOR_SCHEDULE: {
      return {
        ...state,
        mergedDonorSchedules: action.payload,
      };
    }
    case DonorSchedulingActions.UPDATE_WORKING_DONOR_SCHEDULE: {
      return {
        ...state,
        workingDonorSchedule: action.payload,
      };
    }
    case DonorSchedulingActions.UPDATE_REVISION_COMMENT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          revisionComment: action.payload.revisionComment,
          annotation: {
            ...state.workingDonorSchedule?.annotation,
            noteText: action.payload.revisionComment,
          },
        },
      };
    }
    case DonorSchedulingActions.RESET_SELECTED_DONOR_SCHEDULING: {
      return {
        ...state,
        selectedDonorSchedules: [],
        workingDonorSchedule: initialWorkingDonorSchedule,
      };
    }
    case DonorSchedulingActions.RESET_WORKING_DONOR_SCHEDULE: {
      return {
        ...state,
        workingDonorSchedule: initialState.workingDonorSchedule,
      };
    }
    case DonorSchedulingActions.INCREMENT_REFETCH_TRIGGER: {
      return {
        ...state,
        refetchTrigger: state.refetchTrigger + 1,
      };
    }
    case DonorSchedulingActions.UPDATE_ASPIRATION_SITE: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          aspirationSiteId: action.payload.aspirationSiteId,
          aspirationSite: action.payload.aspirationSite,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_BILL_ACCOUNT_CANING_OPTIONS: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          billAccountCaningOption: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_DATE: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          date: action.payload ? new Date(action.payload).toISOString() : null,
          dow: action.payload ? format(action.payload, 'eee') : null,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_NAME: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          name: action.payload ? action.payload : null,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_OWNER: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          owner: {
            id: action.payload?.id,
            name: action.payload?.name,
            code: action.payload?.code,
            priceTier: action.payload?.priceTier,
            aging60: action.payload?.aging60,
            aging90: action.payload?.aging90,
            aging120: action.payload?.aging120,
            aging180: action.payload?.aging180,
            aging365: action.payload?.aging365,
            accountStatus: action.payload?.accountStatus,
            isPwp: action.payload?.isPwp,
          },
          ownerId: action.payload?.id,
          textingAccount: {
            id: action.payload?.id,
            name: action.payload?.name,
            code: action.payload?.code,
          },
          textingAccountId: action.payload?.id,
          textingNumber: action.payload?.primaryTextingNumber,
          billingAccount: {
            id: action.payload?.id,
            name: action.payload?.name,
            code: action.payload?.code,
          },
          billingAccountId: action.payload?.id,
          loadDonorPartners: 100000000,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_DONOR: {
      const currentOwner = state.workingDonorSchedule?.owner;
      const currentOwnerId = state.workingDonorSchedule?.ownerId;
      const currentTextingAccount = state.workingDonorSchedule?.textingAccount;
      const currentTextingAccountId =
        state.workingDonorSchedule?.textingAccountId;
      const currentBillingAccount = state.workingDonorSchedule?.billingAccount;
      const currentBillingAccountId =
        state.workingDonorSchedule?.billingAccountId;

      const shouldUpdateOwner =
        currentOwner === null && currentOwnerId === null;

      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          donor: action.payload,
          donorId: action.payload?.id,
          owner: shouldUpdateOwner ? action.payload?.owner : currentOwner,
          ownerId: shouldUpdateOwner ? action.payload?.ownerId : currentOwnerId,
          textingAccount: shouldUpdateOwner
            ? {
                id: action.payload?.ownerId,
                name: action.payload?.owner?.name,
                code: action.payload?.owner?.code,
              }
            : currentTextingAccount,
          textingAccountId: shouldUpdateOwner
            ? action.payload?.ownerId
            : currentTextingAccountId,
          drug: action.payload?.drug,
          fshId: action.payload?.fshId,
          fsh2Id: action.payload?.fsh2Id,
          drug2: action.payload?.drug2,
          pregnant: action.payload?.pregnant,
          scheduleMasterId: action.payload?.scheduleMasterId,
          scheduleMaster: action.payload?.scheduleMaster,
          billingAccount: shouldUpdateOwner
            ? {
                id: action.payload?.ownerId,
                name: action.payload?.owner?.name,
                code: action.payload?.owner?.code,
              }
            : currentBillingAccount,
          billingAccountId: shouldUpdateOwner
            ? action.payload?.ownerId
            : currentBillingAccountId,
          loadDonorPartners: 100000000,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_DONOR_LOCATION: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          donorLocation: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_PROCEDURE_TIME: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          procedureTime: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_PROGRAM_NAME: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          programName: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_FERTILIZATION_SITE: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          fertilizationSiteId: action.payload.fertilizationSiteId,
          fertilizationSite: action.payload.fertilizationSite,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_PRIORITY: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          priority: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_TEXTING_ACCOUNT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          textingAccount: action.payload,
          textingNumber: action.payload?.primaryTextingNumber,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_TEXTING_NUMBER: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          textingNumber: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_SPECIAL_INSTRUCTIONS: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          specialInstructions: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_CSR: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          csr: {
            fullName: action.payload.fullName,
            id: action.payload.id,
          },
          csrId: action.payload.id,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_ID: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          id: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_DOW: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          dow: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_DONOR_COMMENT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          donorComment: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_PREGNANT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          pregnant: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_POOL: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          pool: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_SHIP: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          ship: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_SHIPMENT_GROUP: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          shipmentGroup: action.payload?.shipmentGroup ?? null,
          shipmentGroupId: action.payload?.shipmentGroupId ?? null,
        },
      };
    }

    case DonorSchedulingActions.UPDATE_CSR_FRZ_TRF: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          csrFrzTrf: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_EMBRYO_COMMENT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          embryoComment: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_FREEZE: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          freeze: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_FREEZE_METHOD: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          freezeMethodId: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_FREEZE_INSTRUCTIONS: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          freezeInstructions: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_EXPORT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          export: action.payload,
          tt:
            action.payload === 0
              ? false
              : action.payload > 0
                ? true
                : undefined,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_NON_EU_COUNTRY: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          nonEUCountry: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_TT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          tt: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_TRANSFER: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          transfer: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_IMPLANT_TYPE: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          implantType: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_FSH_DRUG_1: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          fshId: action.payload.fshId,
          drug: action.payload.drug,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_SCHEDULE_MASTER: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          scheduleMasterId: action.payload.scheduleMasterId,
          scheduleMaster: action.payload.scheduleMaster,
          // fshDrug1Id: action.payload.scheduleMaster.fshId,
          // clinicRanchHaulInId:
          //   action.payload.scheduleMaster.clinicRanchHaulInId,
          // drugShipFeeId: action.payload.scheduleMaster.drugShipFeeId,
          // billDrugs: action.payload.scheduleMaster.billDrugs,
          // freezeMethodId: action.payload.scheduleMaster.freezeMethodId,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_CLINIC_RANCH_HAUL_IN: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          clinicRanchHaulIn: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_TARGET_TIME: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          targetTime: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_FSH_DRUG_2: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          fsh2Id: action.payload.fsh2Id,
          drug2: action.payload.drug2,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_BILL_DRUGS: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          billDrugs: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_DRUG_SHIPPING_FEE: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          drugShippingFee: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_BILLING_ACCOUNT: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          billingAccount: action.payload,
          billingAccountId: action.payload?.id,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_BILL_DONOR_PARTNERSHIP_STATUS: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          loadDonorPartners: action.payload,
        },
      };
    }
    case DonorSchedulingActions.UPDATE_SO_SCHEDULE: {
      return {
        ...state,
        workingDonorSchedule: {
          ...state.workingDonorSchedule,
          soSchedule: action.payload,
          soScheduleId: action.payload?.id,
        },
      };
    }

    default:
      return state;
  }
}
